'use client';

import { RadialGradientBG } from '@jouzen/ecom-components/v3/GradientBG';
import { useGateValue } from '@statsig/react-bindings';
import { redirect } from 'next/navigation';

import MetabolicHealthArticles from './_components/MetabolicHealthArticles';
import { MetabolicHealthDisclaimer } from './_components/MetabolicHealthDisclaimer';
import MetabolicHealthFeatures from './_components/MetabolicHealthFeatures';
import MetabolicHealthHero from './_components/MetabolicHealthHero';
import MetabolicHealthJumbotron from './_components/MetabolicHealthJumbotron';
import MetabolicHealthSpecsCta from './_components/MetabolicHealthSpecsCta';
import { metabolicHealthPageGradients } from './_data/metabolicHealthPageGradients';

const Content = () => {
  const isDexcomSteloEnabled = useGateValue('dexcom_rollout');
  if (!isDexcomSteloEnabled) {
    return redirect('https://ouraring.com/blog/introducing-metabolic-health/');
  }
  return (
    <div data-cy="metabolic-health-page">
      <RadialGradientBG gradients={metabolicHealthPageGradients}>
        <MetabolicHealthHero />
        <MetabolicHealthFeatures />
        <MetabolicHealthJumbotron />
        <MetabolicHealthSpecsCta />
      </RadialGradientBG>
      <MetabolicHealthArticles />
      <MetabolicHealthDisclaimer />
    </div>
  );
};

export default Content;
